import { useLayoutEffect } from 'react'

export const usePageTitle = ( title: string ) => {
	useLayoutEffect( () => {
		// Our heap tracking uses the dash here to track the page.
		// If you ever alter this please confirm heap still tracks page views.
		document.title = `Borg AEMP Integrations - ${title}`
	}, [ title ] )
}
